import React, { useCallback, useEffect, useState } from 'react'
import { Button, Spinner } from 'reactstrap'
import moment from 'moment'
import qs from 'qs'
import oikosApi from '../../../../services/oikos'
import ModalFormulario from '../../../../components/Modals/ModalFormulario/ModalFormulario'
import { selectValues } from '../../../../utils/fc'
import { notifyError } from '../../../../utils/notify'

const TP_FORMULARIO_PESQUISA = 1
const PERGUNTA_PROJ_ID = 18

const ordenarPorLabel = (lista) => {
  if (!Array.isArray(lista)) return []
  return [...lista].sort((a, b) => {
    if (!a.label || !b.label) return 0
    const labelA = a.label.toLowerCase()
    const labelB = b.label.toLowerCase()
    if (labelA < labelB) return -1
    if (labelA > labelB) return 1
    return 0
  })
}

const enrichPerguntas = async (perguntasRaw, formulariosSecundarios) => {
  const perguntas = Array.isArray(perguntasRaw) ? [...perguntasRaw] : []
  let perguntasFinal = []

  for (const [index, pergunta] of perguntas.entries()) {
    if (pergunta.formatoCampo_id === 1 && pergunta.perguntaFormulario_tabRef) {
      const selOptions = await selectValues(
        pergunta.perguntaFormulario_tabRef,
        `${pergunta.perguntaFormulario_tabRef}_id`,
        pergunta.perguntaFormulario_selectLabel,
      )
      perguntas[index].selOptions = ordenarPorLabel(selOptions)

      if (Array.isArray(formulariosSecundarios) && formulariosSecundarios.length > 0) {
        perguntasFinal = perguntas.map((perguntaPrincipal) => {
          for (let i = 0; i < formulariosSecundarios.length; i += 1) {
            const element1 = formulariosSecundarios[i]
            const perguntasQueTemFormularioSecundario = perguntas.filter(
              (p) =>
                perguntaPrincipal.perguntaFormulario_id === p.perguntaFormulario_id &&
                p.perguntaFormulario_id === element1.perguntaFormulario_id,
            )
            if (perguntasQueTemFormularioSecundario.length > 0) {
              for (let j = 0; j < perguntasQueTemFormularioSecundario.length; j += 1) {
                const element2 = perguntasQueTemFormularioSecundario[j]
                return {
                  ...perguntaPrincipal,
                  formSecundario: [
                    element2.formSecundario
                      ? [...element2.formSecundario, element1]
                      : [element1],
                  ],
                }
              }
            }
            return perguntaPrincipal
          }
          return perguntaPrincipal
        })
      }
    } else if (
      pergunta.formatoCampo_id === 1 &&
      !pergunta.perguntaFormulario_tabRef &&
      pergunta.perguntaFormulario_opcoes
    ) {
      try {
        const obj = JSON.parse(pergunta.perguntaFormulario_opcoes)
        perguntas[index].selOptions = Object.entries(obj)
          .map(([label, value]) => ({ label, value }))
          .sort((a, b) => a.value - b.value)
      } catch (e) {
        console.log('opcoes parse error', e)
      }
    }
  }

  const list = perguntasFinal.length > 0 ? perguntasFinal : perguntas
  return list.sort((a, b) => a.perguntaFormulario_ord - b.perguntaFormulario_ord)
}

const MarketingPesquisaForm = ({ project }) => {
  const projId = project?.proj_id

  const [loading, setLoading] = useState(true)
  const [pesquisas, setPesquisas] = useState([])
  const [modalOpenning, setModalOpenning] = useState(false)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [readOnly, setReadOnly] = useState(false)
  const [perguntas, setPerguntas] = useState([])
  const [defaultInputs, setDefaultInputs] = useState({})
  const [selPfs, setSelPfs] = useState([])

  const fetchSelPfs = useCallback(async () => {
    const resSelPfs = await selectValues('pf', 'pf_id', 'pf_nomeExibicao')
    setSelPfs(Array.isArray(resSelPfs) ? resSelPfs : [])
  }, [])

  const loadPesquisas = useCallback(async () => {
    if (!projId) {
      setPesquisas([])
      setLoading(false)
      return
    }
    setLoading(true)
    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'formulario',
        data: {
          tpFormulario_id: TP_FORMULARIO_PESQUISA,
          formulario_ativo: 1,
        },
        fields: {
          '(SELECT formularioDado_resposta FROM formularioDado WHERE perguntaFormulario_id = 18 AND formulario_id = formulario.formulario_id LIMIT 1)': 'proj_id_link',
          "(SELECT AVG(formularioDado_resposta) FROM formularioDado WHERE formularioDado.formulario_id = formulario.formulario_id AND formularioDado.perguntaFormulario_id NOT IN (18, 19) AND 'INT' = (SELECT perguntaFormulario_type FROM perguntaFormulario WHERE perguntaFormulario.perguntaFormulario_id = formularioDado.perguntaFormulario_id) GROUP BY formulario_id)": 'media_nota',
        },
      })}`)

      const list = Array.isArray(res.data) ? res.data : []
      const doProjeto = list
        .filter((f) => String(f.proj_id_link) === String(projId))
        .sort((a, b) => {
          const da = a.formulario_dtCria ? new Date(a.formulario_dtCria).getTime() : 0
          const db = b.formulario_dtCria ? new Date(b.formulario_dtCria).getTime() : 0
          return db - da
        })
      setPesquisas(doProjeto)
    } catch (err) {
      console.error('MarketingPesquisaForm load error:', err)
      notifyError('Não foi possível carregar a pesquisa de satisfação deste projeto.')
      setPesquisas([])
    } finally {
      setLoading(false)
    }
  }, [projId])

  useEffect(() => {
    loadPesquisas()
  }, [loadPesquisas])

  const loadPerguntasBase = async () => {
    const [res, resFormularioSecundario] = await Promise.all([
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'perguntaFormulario',
        data: { tpFormulario_id: TP_FORMULARIO_PESQUISA },
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'tpFormulario',
        data: { tpFormulario_mae: TP_FORMULARIO_PESQUISA },
      })}`),
    ])

    if (!Array.isArray(res.data) || typeof res.data === 'string' || res.data.length === 0) {
      return null
    }

    const secundarios =
      Array.isArray(resFormularioSecundario.data) && typeof resFormularioSecundario.data !== 'string'
        ? resFormularioSecundario.data
        : []

    return enrichPerguntas(res.data, secundarios)
  }

  const handleResponder = async () => {
    if (!projId) return
    setModalOpenning(true)
    try {
      await fetchSelPfs()
      const perguntasSorted = await loadPerguntasBase()
      if (!perguntasSorted) {
        notifyError('Não foi possível carregar as perguntas da pesquisa.')
        return
      }

      const perguntaProj = perguntasSorted.find((p) => p.perguntaFormulario_id === PERGUNTA_PROJ_ID)
      const labelProj = perguntaProj ? perguntaProj.perguntaFormulario_label : '1 - Projeto'

      setPerguntas(perguntasSorted)
      setDefaultInputs({ [labelProj]: projId })
      setReadOnly(false)
      setIsOpenModal(true)
    } catch (err) {
      console.error(err)
      notifyError('Não foi possível abrir o formulário de pesquisa.')
    } finally {
      setModalOpenning(false)
    }
  }

  const handleVerRespostas = async (formulario) => {
    if (!formulario?.formulario_id) return
    setModalOpenning(true)
    try {
      await fetchSelPfs()
      const [perguntasSorted, resRespostas] = await Promise.all([
        loadPerguntasBase(),
        oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'formularioDado',
          data: { formulario_id: formulario.formulario_id },
        })}`),
      ])

      if (!perguntasSorted) {
        notifyError('Não foi possível carregar as perguntas da pesquisa.')
        return
      }

      const respostasObj = {}
      const respostas = Array.isArray(resRespostas.data) ? resRespostas.data : []
      respostas.forEach((resposta) => {
        const pergunta = perguntasSorted.find(
          (p) => p.perguntaFormulario_id === resposta.perguntaFormulario_id,
        )
        if (!pergunta) return
        if (pergunta.formatoCampo_id === 4) {
          respostasObj[pergunta.perguntaFormulario_label] = Number(resposta.formularioDado_resposta)
        } else {
          respostasObj[pergunta.perguntaFormulario_label] = resposta.formularioDado_resposta
        }
      })

      setPerguntas(perguntasSorted)
      setDefaultInputs(respostasObj)
      setReadOnly(true)
      setIsOpenModal(true)
    } catch (err) {
      console.error(err)
      notifyError('Não foi possível abrir as respostas da pesquisa.')
    } finally {
      setModalOpenning(false)
    }
  }

  if (loading) {
    return (
      <div className="d-flex align-items-center py-3">
        <Spinner size="sm" className="mr-2" />
        <span className="text-muted">Carregando pesquisa de satisfação…</span>
      </div>
    )
  }

  const latest = pesquisas[0] || null
  const temPesquisa = pesquisas.length > 0

  return (
    <>
      <div className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-start flex-wrap mb-3">
          <div>
            <h5 className="mb-1">Pesquisa de satisfação</h5>
            <p className="text-muted mb-0" style={{ fontSize: 13 }}>
              {temPesquisa
                ? `Este projeto possui ${pesquisas.length} pesquisa(s) registrada(s).`
                : 'Nenhuma pesquisa de satisfação registrada para este projeto.'}
            </p>
          </div>
          <div className="mt-2 mt-md-0">
            {modalOpenning ? (
              <Spinner size="sm" />
            ) : (
              <Button color="primary" size="sm" onClick={handleResponder} disabled={!projId}>
                {temPesquisa ? 'Nova pesquisa' : 'Responder'}
              </Button>
            )}
          </div>
        </div>

        {temPesquisa ? (
          <div className="border rounded p-3" style={{ background: '#f8f9fa' }}>
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <div style={{ fontSize: 13 }}>
                  <strong>Status:</strong>{' '}
                  <span className="text-success font-weight-bold">Pesquisa realizada</span>
                </div>
                {latest?.formulario_dtCria && (
                  <div style={{ fontSize: 13 }} className="mt-1">
                    <strong>Última pesquisa:</strong>{' '}
                    {moment(latest.formulario_dtCria).format('DD/MM/YYYY')}
                  </div>
                )}
                <div style={{ fontSize: 13 }} className="mt-1">
                  <strong>Média:</strong>{' '}
                  {latest?.media_nota != null && latest.media_nota !== ''
                    ? Number(latest.media_nota).toFixed(2)
                    : '—'}
                </div>
              </div>
              <Button
                color="link"
                size="sm"
                className="px-0"
                onClick={() => handleVerRespostas(latest)}
                disabled={modalOpenning}
              >
                Ver respostas
              </Button>
            </div>

            {pesquisas.length > 1 && (
              <div className="mt-3 pt-2 border-top">
                <div className="text-muted mb-2" style={{ fontSize: 12 }}>
                  Outras pesquisas deste projeto
                </div>
                {pesquisas.slice(1).map((p) => (
                  <div
                    key={p.formulario_id}
                    className="d-flex justify-content-between align-items-center mb-1"
                    style={{ fontSize: 13 }}
                  >
                    <span>
                      {p.formulario_dtCria
                        ? moment(p.formulario_dtCria).format('DD/MM/YYYY')
                        : 'Sem data'}
                      {' · média '}
                      {p.media_nota != null && p.media_nota !== ''
                        ? Number(p.media_nota).toFixed(2)
                        : '—'}
                    </span>
                    <Button
                      color="link"
                      size="sm"
                      className="px-0"
                      onClick={() => handleVerRespostas(p)}
                      disabled={modalOpenning}
                    >
                      Ver
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="border rounded p-3" style={{ background: '#fff' }}>
            <span style={{ fontSize: 13 }}>
              <strong>Status:</strong>{' '}
              <span className="text-danger font-weight-bold">Pesquisa não realizada</span>
            </span>
          </div>
        )}
      </div>

      {selPfs && (
        <ModalFormulario
          title={readOnly ? 'Respostas da Pesquisa de Satisfação' : 'Formulário de Pesquisa de Satisfação'}
          openModal={isOpenModal}
          onClosed={() => setIsOpenModal(false)}
          onConfirm={loadPesquisas}
          data={perguntas}
          size="lg"
          selPfs={selPfs}
          fetchSelPfs={fetchSelPfs}
          defaultInputs={defaultInputs}
          readOnly={readOnly}
        />
      )}
    </>
  )
}

export default MarketingPesquisaForm
